import { Route, Routes } from "react-router-dom";
import { Storage } from "../../modules/Storage";
import Chat from "../../pages/Chat";
import ChatEn from "../../pages/ChatEn";
import EditProfile from "../../pages/EditProfile";
import EditProfileEn from "../../pages/EditProfileEn";
import EditResume from "../../pages/EditResume";
import EditResumeEn from "../../pages/EditResumeEn";
import FindPassword from "../../pages/FindPassword";
import FindPasswordEn from "../../pages/FindPasswordEn";
import Home from "../../pages/Home";
import HomeEn from "../../pages/HomeEn";
import Join from "../../pages/Join";
import JoinAttorney from "../../pages/JoinAttorney";
import JoinAttorneyEn from "../../pages/JoinAttorneyEn";
import JoinEn from "../../pages/JoinEn";
import Login from "../../pages/Login";
import LoginEn from "../../pages/LoginEn";
import Matching from "../../pages/Matching";
import MatchingEn from "../../pages/MatchingEn";
import Mypage from "../../pages/Mypage";
import MypageEn from "../../pages/MypageEn";
import Notice from "../../pages/Notice";
import NoticeDetail from "../../pages/NoticeDetail";
import NoticeDetailEn from "../../pages/NoticeDetailEn";
import NoticeEn from "../../pages/NoticeEn";
import PatentInfo from "../../pages/PatentInfo";
import PreMatching from "../../pages/PreMatching";
import PreMatchingEn from "../../pages/PreMatchingEn";
import Pricing from "../../pages/Pricing";
import PricingEn from "../../pages/PricingEn";
import ViewResume from "../../pages/ViewResume";
import ViewResumeEn from "../../pages/ViewResumeEn";

const MainRouter = () => {
  const isLogin = Storage.get("accountKey") ? true : false;

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Home />} />"
      <Route path="/login" element={<Login />} />
      <Route path="/join" element={<Join />} />
      <Route path="/joinAttorney" element={<JoinAttorney />} />
      <Route path="/preMatching" element={<PreMatching />} />
      <Route path="/preMatching/:field" element={<PreMatching />} />
      <Route path="/matching/:preMatchingId" element={isLogin ? <Matching /> : <Login />} />
      <Route path="/mypage" element={isLogin ? <Mypage /> : <Login />} />
      <Route path="/mypage/modify" element={isLogin ? <EditProfile /> : <Login />} />
      <Route path="/mypage/resumeModify" element={isLogin ? <EditResume /> : <Login />} />
      <Route path="/chat" element={isLogin ? <Chat /> : <Login />} />
      <Route path="/findPassword" element={<FindPassword />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/notice/:kind" element={<Notice />} />
      <Route path="/notice/detail/:id" element={<NoticeDetail />} />
      <Route path="/viewResume/:id" element={<ViewResume />} />
      <Route path="/mypage/patentInfo" element={isLogin ? <PatentInfo /> : <Login />} />
      {/* english pages */}
      <Route path="/en/home" element={<HomeEn />} />
      <Route path="/en/login" element={<LoginEn />} />
      <Route path="/en/join" element={<JoinEn />} />
      <Route path="/en/joinAttorney" element={<JoinAttorneyEn />} />
      <Route path="/en/preMatching" element={<PreMatchingEn />} />
      <Route path="/en/preMatching/:field" element={<PreMatchingEn />} />
      <Route path="/en/matching/:preMatchingId" element={isLogin ? <MatchingEn /> : <LoginEn />} />
      <Route path="/en/mypage" element={isLogin ? <MypageEn /> : <LoginEn />} />
      <Route path="/en/mypage/modify" element={isLogin ? <EditProfileEn /> : <LoginEn />} />
      <Route path="/en/mypage/resumeModify" element={isLogin ? <EditResumeEn /> : <LoginEn />} />
      <Route path="/en/chat" element={isLogin ? <ChatEn /> : <LoginEn />} />
      <Route path="/en/findPassword" element={<FindPasswordEn />} />
      <Route path="/en/pricing" element={<PricingEn />} />
      <Route path="/en/notice/:kind" element={<NoticeEn />} />
      <Route path="/en/notice/detail/:id" element={<NoticeDetailEn />} />
      <Route path="/en/viewResume/:id" element={<ViewResumeEn />} />
    </Routes>
  );
};

export default MainRouter;
